import { isIOSDevice } from '../../../utils/browser';

/**
 * Get the internal app route for a spotlight.
 *
 * @param spotlightId - The spotlight ID to navigate to
 * @param entryPoint - Optional entry point for analytics tracking (e.g., 'email', 'slack')
 */
export const getSpotlightRoute = (spotlightId: string, entryPoint?: string): string => {
	const basePath = `/spotlight/employee/${spotlightId}`;
	if (!entryPoint) return basePath;
	return `${basePath}?entry_point=${encodeURIComponent(entryPoint)}`;
};

/**
 * Open a spotlight URL, handling iOS vs non-iOS behavior.
 *
 * On iOS devices, we use in-app navigation because iOS webviews behave poorly
 * with target="_blank" (causes tab jump and back navigation issues).
 *
 * On other platforms, we open the spotlight in a new tab.
 *
 * @param spotlightId - The spotlight ID to navigate to
 * @param spotlightUrl - The full URL to open (used on non-iOS)
 * @param navigate - React Router navigate function (used on iOS)
 * @param entryPoint - Optional entry point for analytics tracking (e.g., 'email', 'slack')
 */
export const openSpotlight = (spotlightId: string, spotlightUrl: string, navigate: (path: string) => void, entryPoint?: string): void => {
	if (isIOSDevice()) {
		navigate(getSpotlightRoute(spotlightId, entryPoint));
	} else {
		const url = entryPoint ? `${spotlightUrl}${spotlightUrl.includes('?') ? '&' : '?'}entry_point=${encodeURIComponent(entryPoint)}` : spotlightUrl;
		window.open(url, '_blank', 'noopener,noreferrer');
	}
};
